import { KeyValue } from '@/main/models/common';

export enum DeliveryTypeTypes {
  GET_DELIVERYTYPES = '@deliveryType/GET_DELIVERYTYPES',
  SAVE_DELIVERYTYPES = '@deliveryType/SAVE_DELIVERYTYPES',
  RESET_REDUCER_DELIVERYTYPES = '@deliveryType/RESET_REDUCER_DELIVERYTYPES'
}

export interface DeliveryTypeState {
  readonly deliveryTypes: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetDeliveryTypes {
  type: typeof DeliveryTypeTypes.GET_DELIVERYTYPES;
}

export interface SaveDeliveryTypes {
  type: typeof DeliveryTypeTypes.SAVE_DELIVERYTYPES;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerDeliveryTypes {
  type: typeof DeliveryTypeTypes.RESET_REDUCER_DELIVERYTYPES;
}

export type DeliveryTypeActionTypes =
  | GetDeliveryTypes
  | SaveDeliveryTypes
  | ResetReducerDeliveryTypes;
